import { useState } from "react";
import DocRenderer from "@/components/admin/DocBlocks";
import {
  PRICING_STRATEGY,
  PRICING_STRATEGY_META,
  SERVICE_GUIDE,
  SERVICE_GUIDE_META,
} from "@/content/pricingStrategy";

export default function PricingDoc() {
  const [view, setView] = useState("strategy");
  return (
    <div>
      <div className="mb-6 flex gap-2 no-print">
        <button
          data-testid="pricing-view-strategy"
          onClick={() => setView("strategy")}
          className={`rounded-full px-5 py-2 text-sm font-bold transition-colors ${
            view === "strategy" ? "bg-terracotta text-white" : "bg-white border border-border text-navy/70"
          }`}
        >
          Strategy & decisions
        </button>
        <button
          data-testid="pricing-view-guide"
          onClick={() => setView("guide")}
          className={`rounded-full px-5 py-2 text-sm font-bold transition-colors ${
            view === "guide" ? "bg-terracotta text-white" : "bg-white border border-border text-navy/70"
          }`}
        >
          Client service guide
        </button>
      </div>
      {view === "strategy" ? (
        <DocRenderer meta={PRICING_STRATEGY_META} sections={PRICING_STRATEGY} testId="pricing-strategy-doc" />
      ) : (
        <DocRenderer
          meta={{ ...SERVICE_GUIDE_META, updated: "Print this page (or use Download as PDF) to share with prospects" }}
          sections={SERVICE_GUIDE}
          testId="service-guide-doc"
        />
      )}
    </div>
  );
}
